import { ValidationError } from 'yup';
import { isNullOrUndefined } from '@utils/utils';
import { useTranslation } from 'react-i18next';

// @ts-ignore
export const validate = (s, data, context?: any): ValidationError[] => {
  const schema = typeof s === 'function' ? s(data) : s;
  try {
    schema.validateSync(data, {
      abortEarly: false,
      recursive: true,
      strict: false,
      context,
    });
    return [];
  } catch (err) {
    // A yup failure carries its findings in `inner`; anything else is the schema itself blowing up —
    // a value it cannot even look at, say. Reporting that as "no errors" would let the form submit
    // data nothing has checked, so it counts as one error instead, and says so in the console.
    // @ts-ignore
    if (Array.isArray(err.inner)) return err.inner;

    console.error('Validation could not run; treating the form as invalid.', err);
    return [new ValidationError('validation.unexpectedError', data, '')];
  }
};

interface ComponentPros {
  errors: ValidationError[];
  path: string;
  wrapperStyle?: any;
  overidedErrorMessage?: string;
}

/**
 *
 * @deprecated use validationUtils findErrorMessage instead, new method provides better handling of error specific errors
 */
export const findValidationMessage = (errors: ValidationError[], path: string, t: any) => {
  if (isNullOrUndefined(errors)) return null;

  const error = errors.find(e => e.path === path);
  if (isNullOrUndefined(error)) return undefined;
  return t(`validation.${error.type}`);
};

export const findValidationMessageRaw = (errors: ValidationError[], path: string) => {
  if (isNullOrUndefined(errors)) return null;

  const error = errors.find(e => e.path === path);
  if (isNullOrUndefined(error)) return undefined;
  return error;
};

/**
 * This method is used for checking, if there is any validation problem for given prefix.
 * ie: company.name, company.address, company.city => prefix = company
 * @param errors
 * @param prefix
 */
export const hasValidationProblemForPrefix = (errors: ValidationError[], prefix: string) => {
  if (isNullOrUndefined(errors)) return false;

  const error = errors.find(e => e.path.startsWith(prefix));
  if (isNullOrUndefined(error)) return false;
  return true;
};

/**
 * This method is used for checking, if there is any validation problem for given prefix.
 * ie: company.name, company.address, company.city => prefix = company
 * @param errors
 * @param prefix
 */
export const findValidationProblemsForPrefix = (errors: ValidationError[], prefix: string) => {
  if (isNullOrUndefined(errors)) return null;

  const ret = errors.filter(e => e.path.startsWith(prefix));
  if (isNullOrUndefined(ret)) return null;
  return ret;
};

const ValidationDiv: React.FC<ComponentPros> = ({ path, errors, overidedErrorMessage, wrapperStyle }) => {
  const { t } = useTranslation('common');

  const error = errors?.find(e => e.path === path);
  if (error)
    return (
      <div className="p-invalid-feedback validationErrorMessage" style={wrapperStyle}>
        {!overidedErrorMessage && <>{t(`validation.${error.type}`)}</>}
        {overidedErrorMessage && <>{overidedErrorMessage}</>}
      </div>
    );
  return <div className="p-invalid-feedback "></div>;
};

export default ValidationDiv;
